module.exports = __webpack_public_path__ + "h5/img/lvka_1.838ae75f.png";